import React from 'react'
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'redux'
import { connect } from 'react-redux'
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import Box from '@material-ui/core/Box';
import Popover from '@material-ui/core/Popover';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import { firestoreConnect } from 'react-redux-firebase'
import { Redirect, Link as RouterLink } from 'react-router-dom'
import { getCollection } from '../../constant'
import Button from '@material-ui/core/Button';
import Avatar from '@material-ui/core/Avatar';
import ChangePassword from './ChangePassword';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

const styles = {
  avatar: {
    margin: 10,
  },
  notiMain: {
    maxWidth: 400,
    minWidth: 250,
    width: '100%'
  },
  row: {
    display: 'flex',
    justifyContent: 'center',
  },
  link: {
    textDecoration: 'none',
    color: "white"
  },
  root: {
    width: '100%',
    maxWidth: 400,
    // backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    maxHeight: 300,
  },
  listSection: {
    backgroundColor: 'inherit',
  },
  ul: {
    backgroundColor: 'inherit',
    padding: 0,
  },

};

const defaultProps = {
  color: 'secondary',
  children: <NotificationsActiveIcon style={{ color: '#fff' }} />,
};

class Profile extends React.Component {

  state = {
    open : false
  }

  handleListItemClick = (event, selectedIndex, notification) => {
    const { firestore } = this.props;
    firestore.update(
      { collection: getCollection(this.props.profile, 'notifications'), doc: notification.id },
      { read: true },
    )
      .then(() => { }, (err) => { },
      );
  };

  handleClose = () => {
    this.setState({ open: false });
  }

  render() {
    const { classes, profile, auth, firebase } = this.props;
    const {open} = this.state;

    if (!auth.uid) return <Redirect to='/signin' />

    return (
      <React.Fragment>
        <div style={{display:'inline-block'}}>
          <PopupState variant="popover" popupId="demo-popup-popover">
            {(popupState) => (
              <div>
                <Button color="inherit" {...defaultProps} {...bindTrigger(popupState)}><Avatar className={classes.avatar}>{profile.initials}</Avatar> </Button>
                <Popover
                  {...bindPopover(popupState)}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                >
                  <Box p={0} className={classes.notiMain}>
                    <div className={classes.root}>
                      <List component="nav" aria-label="main mailbox folders">
                        <ListItem
                          button
                          onClick={() => { this.setState({ open: true }); popupState.close() }}
                        >
                          <ListItemText primary="Change Password" />
                        </ListItem>
                        {/* <Divider /> */}
                      </List>
                    </div>
                  </Box>
                </Popover>
              </div>
            )}
          </PopupState>
        </div>
        
        <ChangePassword open={open} handleClose={this.handleClose} firebase={firebase} />
        
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
  }
}

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => {
    return []
  })
)(withStyles(styles)(Profile));
